/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';

/**
 * 
 * @export
 * @interface BulkDeleteWorkPatternOverridesResponse
 */
export interface BulkDeleteWorkPatternOverridesResponse {
    /**
     * 
     * @type {BatchSummary}
     * @memberof BulkDeleteWorkPatternOverridesResponse
     */
    data: BatchSummary;
}

/**
 * Check if a given object implements the BulkDeleteWorkPatternOverridesResponse interface.
 */
export function instanceOfBulkDeleteWorkPatternOverridesResponse(value: object): value is BulkDeleteWorkPatternOverridesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkDeleteWorkPatternOverridesResponseFromJSON(json: any): BulkDeleteWorkPatternOverridesResponse {
    return BulkDeleteWorkPatternOverridesResponseFromJSONTyped(json, false);
}

export function BulkDeleteWorkPatternOverridesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteWorkPatternOverridesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BatchSummaryFromJSON(json['data']),
    };
}

  export function BulkDeleteWorkPatternOverridesResponseToJSON(json: any): BulkDeleteWorkPatternOverridesResponse {
      return BulkDeleteWorkPatternOverridesResponseToJSONTyped(json, false);
  }

  export function BulkDeleteWorkPatternOverridesResponseToJSONTyped(value?: BulkDeleteWorkPatternOverridesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BatchSummaryToJSON(value['data']),
    };
}

